/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76154ResTaskTargetObj {
  
  /**  */
  bizNo?: string;
  
  /**  */
  targetType?: string;
  
  /**  */
  desc?: string;
  
  /**  */
  unit?: string;
  
  /**  */
  num?: number;
  
  /**  */
  progressNum?: number;
  
};
    
  



export interface API76154Req {
  
    bizNo: string;
  
};



export interface API76154Res {
  /** 任务id  */
  bizNo?: string;
  /** 任务内容  */
  taskTitle?: string;
  /** 是否逾期0正常1逾期  */
  taskDurationStatus?: number;
  /** 任务状态  */
  status?: string;
  /** 是否可以完成  */
  isExecuted?: boolean;
  /** 任务用户 ,String  */
  userList?: string[];
  /** 任务进度  */
  progress?: number;
  /** 任务目标 ,TaskTargetResp  */
  taskTarget?: IAPI76154ResTaskTargetObj;
  /** 任务汇报列表 ,TaskInstanceProgressResp  */
  children?: any[];
  
};


// 接口函数 76154 任务进度查询

export interface IUseGetAPI76154Return {
  /** 任务进度查询: 接口请求状态 */
  isAPI76154Loading: boolean;
  /** 任务进度查询: 接口请求返回数据 */
  dataAPI76154: API76154Res;
  /**  任务进度查询: 接口数据请求方法 */
  fetchAPI76154Data: (inputs: API76154Req, config?: YWRequestConfig) => Promise<API76154Res>;
  /** 任务进度查询: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76154 = ():IUseGetAPI76154Return => {
  let isMount = true;
  const [isAPI76154Loading, setIsAPI76154Loading] = useState(false);
  const [dataAPI76154, setDataAPI76154] = useState<API76154Res>({} as API76154Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/progress/view`;

  const fetchAPI76154Data = async (inputs: API76154Req, config?: YWRequestConfig): Promise<API76154Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76154Req>) || {}) as API76154Req;
    
  
    if ( isMount ) {
      setIsAPI76154Loading(true);
    }

    try {
      
      const res: any = await Request.get<API76154Res>(`${basePath}/yoaichat-web/task/instance/progress/view/${parseParams<API76154Req>(params)}`, {
        loginHost: loginPath,
        ...config
      });
      
      if (isMount) {
        setDataAPI76154(res || {} as API76154Res);
        setIsAPI76154Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76154Loading(false);
      }
      return false as unknown as API76154Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76154Loading,
    dataAPI76154,
    fetchAPI76154Data,
    requestUrl,
  }
}

